import CommonAxios from "../../Utilities/CommonAxios";
import { useNavigate } from "react-router-dom";
import {
    addMember,
    donationCollection,
    findMemberByMobile,
    getAgentSingleCollectionHistory,
    getAgentSinglePromisedHistory,
    getAgentWiseMember,
    getAllAgentForDropDown,
    getAllCollectionAmount,
    getAllMember, getAllMemberAtonce, getAllMembersForExport,
    getAllOrganization,
    getAllPromisedCollectionAmount,
    getTotalDue, importMember,
    updateMember
} from "../../AllRoutes/ApiRoute";
import CommonLoader from "../../Utilities/CommonLoader";
import { MemberSlice } from "../Slice/MemberSlice";
import CommonToast from "../../Utilities/CommonToast";
import axios from "axios";
import { membersExportMethod } from "../../Component/AllMemberComponent/Utilities/MembersExportMethod";


// get members total due
export const getMembersTotalDue = payload => dispatch => {
    // db operation
    CommonAxios.get(getTotalDue).then(res => {
        if (res.data.status == true) {
            dispatch(MemberSlice.actions.getTotalDueReducer(res.data))
        }
    }).catch(err => {
        console.log(err)
    })
}

export const getAllMemberAction = payload => dispatch => {
    // getting data from payload
    const {
        setDataForTable,
        pageConfigurationFromCommonPagination
    } = payload

    try {
        // disable button
        pageConfigurationFromCommonPagination.pagesDisable()
    } catch (e) {

    }

    // db operation
    CommonAxios.post(getAllMember, payload).then(res => {
        try {
            // enable button
            pageConfigurationFromCommonPagination.pagesEnable()
        } catch (e) {

        }
        if (res.data.status === true) {
            // data set
            setDataForTable(res.data);
        }
    }).catch(err => {
        try {
            // enable button
            pageConfigurationFromCommonPagination.pagesEnable()
        } catch (e) {

        }
        console.log(err)
    })
}

// get all member at once action
export const getAllMemberAtOnceAction = payload => dispatch => {
    const { setDataForTable,
        pageConfigurationFromCommonPagination
    } = payload

    try {
        // disable button
        pageConfigurationFromCommonPagination.pagesDisable()
    } catch (e) {

    }

    // db operation
    CommonAxios.post(getAllMemberAtonce, payload).then(res => {
        try {
            // enable button
            pageConfigurationFromCommonPagination.pagesEnable()
        } catch (e) {

        }
        if (res.data.status === true) {
            // data set
            setDataForTable(res.data);
        }
    }).catch(err => {
        try {
            // enable button
            pageConfigurationFromCommonPagination.pagesEnable()
        } catch (e) {

        }
        console.log(err)
    })
}


export const getAgentWiseMemberAction = payload => dispatch => {
    // getting data from payload
    const {
        setDataForTable,
        pageConfigurationFromCommonPagination
    } = payload


    CommonAxios.post(getAgentWiseMember, payload).then(res => {
        try {
            // enable button
            pageConfigurationFromCommonPagination.pagesEnable()
        } catch (e) {

        }
        if (res.data.status === true) {
            // data set
            setDataForTable(res.data);
        }
    }).catch(err => {
        try {
            // enable button
            pageConfigurationFromCommonPagination.pagesEnable()
        } catch (e) {

        }
        console.log(err)
    })
}


// add member action
export const addMemberAction = payload => dispatch => {
    const {
        btnRef,
        setAddMemberModelShow,
        setAllMemberReload,
        setMemberIdCardModelShow,
        setIdData,
        reset,
    } = payload

    // handle button loader
    CommonLoader.btn(btnRef)


    CommonAxios.post(addMember, payload).then(res => {
        // handle button loader
        CommonLoader.btn(btnRef)

        if (res.data.status === true) {
            reset()
            //Add member model close
            setAddMemberModelShow(false)

            //all Agent table reload
            setAllMemberReload(prev => !prev)
            // toast
            CommonToast.success("Donor Create Successfully!")
            // id data set
            setIdData(res.data.data)
            // // id Model Open
            // setMemberIdCardModelShow(true)

        } else {
            CommonToast.error("Donor Create failed!")
        }

    }).catch(err => {
        // handle button loader
        CommonLoader.btn(btnRef)
    })

}

// edit Member action
export const editMemberAction = payload => dispatch => {
    const {
        btnRef,
        setEditMemberModelShow,
        setAllMemberReload,
        setGetSingleMemberData,
        setAddMemberModelShow,
        reset
    } = payload

    // handle button loader
    CommonLoader.btn(btnRef)


    CommonAxios.post(updateMember, payload).then(res => {
        // handle button loader
        CommonLoader.btn(btnRef)

        if (res.data.status === true) {
            // single data close
            setGetSingleMemberData({})
            // reset form
            reset()
            // modal close
            setEditMemberModelShow(false)
            setAddMemberModelShow(false)
            //all Agent table reload
            setAllMemberReload(prev => !prev)
            // toast
            CommonToast.success("Donor Update Successfully!")
        } else {
            CommonToast.error("Donor Update failed!")
        }

    }).catch(err => {
        // handle button loader
        CommonLoader.btn(btnRef)
    })

}

// find member by mobile action
export const findMemberByMobileAction = payload => dispatch => {
    const { member_id, handleFieldDisability, setGetSingleMemberData, formType } = payload
    // handle disability
    handleFieldDisability(true)
    // db operation
    CommonAxios.post(findMemberByMobile, payload).then(res => {
        // handle disability
        handleFieldDisability(false)
        if (res?.data?.data) {
            if (formType == "Update" && member_id && res?.data?.data?.id == member_id) {
                // when the form update and it types it own number it won't return any warning
                return false
            } else if (formType == "Update" && member_id && res?.data?.data?.id != member_id) {
                CommonToast.warning(`Mobile number is already exist!`)
            } else if (formType == "add" && member_id && res?.data?.data?.id == member_id) {
                return false
            }
            else if (formType == "add" && member_id && res?.data?.data?.id != member_id) {
                setGetSingleMemberData(res?.data?.data)
                CommonToast.warning(`Mobile number is already exist!`)
            }
            else if (!member_id) {
                CommonToast.warning(`Mobile number is already exist!`)
                setGetSingleMemberData(res?.data?.data)
            }
        }
    }).catch(err => {
        // handle disability
        handleFieldDisability(false)

    })
}

// Organization List action
export const organizationAction = payload => dispatch => {
    const {
        setOrganizationList
    } = payload
    CommonAxios.get(getAllOrganization, payload).then(res => {

        if (res.data.status === true) {
            setOrganizationList(res.data.data)

        }

    }).catch(err => {
        // handle button loader

    })
}
// CollectionAmount List action
export const collectionAmountAction = payload => dispatch => {
    const {
        setGetCollectionAmount
    } = payload
    CommonAxios.get(getAllCollectionAmount, payload).then(res => {

        if (res.data.status === true) {
            setGetCollectionAmount(res.data.data)

        }

    }).catch(err => {
        // handle button loader

    })
}

// promised CollectionAmount List action
export const promisedCollectionAmountAction = payload => dispatch => {
    const {
        setGetCollectionAmount
    } = payload
    CommonAxios.get(getAllPromisedCollectionAmount, payload).then(res => {

        if (res.data.status === true) {
            setGetCollectionAmount(res.data.data)

        }

    }).catch(err => {
        // handle button loader

    })
}

// get agent for dropdown action
export const getAllAgentForDropDownAction = payload => dispatch => {
    const {
        setAgentIds
    } = payload

    CommonAxios.get(getAllAgentForDropDown, payload).then(res => {
        if (res.data.status === true) {
            setAgentIds(res.data.data)
        }
    }).catch(err => {
        // handle button loader

    })
}





// Member Collection action
export const memberCollectionAction = payload => dispatch => {
    const {
        btnRef,
        reset,
        setAllMemberReload,
        setDonationModelShow,
        setOrganization,
        navigate
    } = payload

    // handle button loader
    CommonLoader.btn(btnRef)

    CommonAxios.post(donationCollection, payload).then(res => {
        // handle button loader
        CommonLoader.btn(btnRef)

        if (res.data.status === true) {
            CommonToast.success(res.data.message)
            setDonationModelShow(false)
            setOrganization({})
            if (res.data.data?.id) {
                if (res?.data?.collection_type == "Cash collection") {
                    navigate(`/print?id=${res.data.data?.id}`);
                } else {
                    navigate(`/print?promise_token=${res.data.data?.id}`);
                }
            } else {

            }

        } else {
            CommonToast.error(res?.data?.message || "Donor Collection failed!")
        }

    }).catch(err => {
        // handle button loader
        CommonLoader.btn(btnRef)
    })
}




// Print action
export const getPrintAction = payload => dispatch => {
    const {
        setPrintDetails,
        setPrintDataAgent
    } = payload



    CommonAxios.post(getAgentSingleCollectionHistory, payload).then(res => {

        if (res.data.status === true) {
            setPrintDetails(res.data.data)
            setPrintDataAgent(res.data.userdetail)
        }

    }).catch(err => {
        // handle button loader 
        console.log(err)
    })
}


// Promised Print action
export const getPromisedPrintAction = payload => dispatch => {
    const {
        setPrintDetails,
        setPrintDataAgent
    } = payload



    CommonAxios.post(getAgentSinglePromisedHistory, payload).then(res => {

        if (res.data.status === true) {
            setPrintDetails(res.data.data)
            setPrintDataAgent(res.data.userdetail)
        }

    }).catch(err => {
        // handle button loader 
        console.log(err)
    })
}








// import member action
export const importMemberAction = payload => dispatch => {
    // getting data form payload
    const {
        setImportMemberModal,
        setAllMemberReload,
        submitRef
    } = payload
    // handle button loader
    CommonLoader.btn(submitRef)
    // db operation
    CommonAxios.post(importMember, payload).then(res => {
        // handle button loader
        CommonLoader.btn(submitRef)
        if (res.data.status == true) {
            setImportMemberModal(false)
            setAllMemberReload(prev => !prev)
            CommonToast.success("Members imported successfully.")
        } else {
            CommonToast.error("Members imported failed.")
        }
    }).catch(err => {
        // handle button loader
        CommonLoader.btn(submitRef)
    })
}

// get all members for export action
export const getAllMembersForExportAction = payload => dipsatch => {
    // getting data form payload
    const { membersExportRef } = payload
    // handle button loader
    CommonLoader.btn(membersExportRef)
    // db operation
    CommonAxios.post(getAllMembersForExport, payload).then(res => {
        // handle button loader
        CommonLoader.btn(membersExportRef)
        if (res.data.status == true) {
            // members export
            membersExportMethod(res.data.data)
        } else {
            CommonToast.error("members export failed.")
        }
    }).catch(err => {
        // handle button loader
        CommonLoader.btn(membersExportRef)
    })
}
